import { Component, ContentChild, Input, OnInit, TemplateRef } from '@angular/core';

import { RewardableActionType } from '@genesis-frontend/genesis-utilities';

@Component({
    selector: 'genesis-frontend-board-card',
    templateUrl: './board-card.component.html',
    styleUrls: ['./board-card.component.scss']
})
export class BoardCardComponent implements OnInit {
    @Input() title = '';
    @Input() subTitle = '';
    @Input() text = '';
    @Input() imageSource = '';
    @Input() imageAlternativeText = '';
    @Input() index: number | null = null;
    @Input() cardType = '';
    @Input() id = '';
    @Input() rewardableActionType: RewardableActionType | null = null;
    @Input() rewardEventCode = '';
    @Input() headingLevel: 1 | 2 | 3 | 4 | 5 | 6 = 2;

    rewardRibbonId = '';

    @ContentChild('image', { static: true })
        imageTemplate: TemplateRef<HTMLElement> | null = null;

    @ContentChild('info', { static: true })
        infoTemplate: TemplateRef<HTMLElement> | null = null;

    @ContentChild('actions', { static: true })
        actionsTemplate: TemplateRef<HTMLElement> | null = null;

    @ContentChild('status', { static: true })
        statusTemplate: TemplateRef<HTMLElement> | null = null;

    ngOnInit(): void {
        if (this.index != null) {
            this.rewardRibbonId = `${this.cardType}-card-reward-ribbon-${this.index}`;
        }
    }
}
